module.exports = __webpack_public_path__ + "img/cutting-edge-cn-3.951445f.jpg";